import api from "@/api/axiosApi";
import handleHttpError from "@/util/HttpErrorHandler";
const API_URL = `/champs_model`;

export const allChampsModel = async()=> {
    try {
        const response = await api.get(API_URL);
        return response.data;
        } catch (error) {
        handleHttpError(error, "Erreur lors de la récupération de la liste des champs");

        console.error('Error fetching Champs:', error);
        return [];
        }
}